
import { useState } from "react";
import { Typography, Card } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import MessageSuccess from "../../../../../messages/messageSuccess";
import MessageError from "../../../../../messages/messageError";
import { useNavigate, useParams } from "react-router-dom";
import FazerObservacoes from "../../../../components/fazerObservacoes.";
import api from "../../../../../services/api";
import * as yup from 'yup'; // VALIDACAO
import ButtonLeft from "../../../../../utils/buttonLeft";
import HeaderGestorConfigs from "../../../../../utils/headerGestorConfigs";


export default function ApproveProduto({ producto, setProduto, solicitacaoImportacao }) {
    const { id } = useParams()
    const navigate = useNavigate()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    // const baseUrl = window.location.origin;
    const dispatch = useDispatch()

    const handleApproveProducto = (assunto) => {
        setOpen(true)
        api.post('producto/approve/importacao', {
            solicitacaoImportacaoId: id,
            productoId: producto._id,
            userId: user?._id
        }).then(response => {
            obs && HandleCreateobservacao("Importação");
            dispatch({
                type: 'alert',
                payload: { alert: 'Producto aprovado com sucesso.!' },
            });
            setProduto(response.data.producto);
            navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}?update=${response.data.producto._id}`)
        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
        }).finally(() => setOpen(false))
    }

    async function HandleCreateobservacao(assunto) {
        setOpen(true)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', {
            assunto: assunto,
            descricao: obs,
            userId: user._id,
            estabelecimentoId: solicitacaoImportacao.importador._id
        }).then(res => {
            // console.log(res)
            setOpen(false)
            setMessageSuccess(res.data.msg)

        }).catch(error => {
            // console.log(error)
            setMessageError(error.response.data.message)
            setOpen(false)
        })
    }

    async function validate() {
        setMessageError('');

        let schema = yup.object().shape({
            observacao: yup.string("Necessário inserir as observações").required("Necessário inserir observações"),
        })

        try {
            await schema.validate({ 'observacao': obs })
            handleApproveProducto()
        } catch (error) {
            setMessageError(error.errors);
        }
        return false
    }


    return (
        <Card style={{ padding: 20, paddingBottom: 30 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <div style={{ marginBottom: 30 }}>

                <HeaderGestorConfigs
                    menu={false}
                    configArea={''}
                    title={' CONFIRMAÇÃO DE APROVAÇÃO'}
                />

                {/* {action === 'approve' && */}
                <Typography >
                    Ao comfirmar esta ação estarás a afirmar que análisaste correctamente
                    toda informação deste producto e os documentos anexado neste processo estão em conformidade!
                </Typography>
                {/* } */}

                <FazerObservacoes setObs={setObs} obs={obs} />

                <ButtonLeft
                    title={'Confirmar'}
                    funcao={handleApproveProducto}
                    load={open}
                    disabled={!producto?.categoria}
                >
                    <Button color="error" onClick={() => navigate(`/admin/dmts/gest/solicitacao-de-importacao/${id}`)} >Cancelar</Button>
                </ButtonLeft>
            </div>
        </Card>
    )
}